const animation = require("./timerTurning.json");

module.exports = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid'
    },
}